/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconWindElectricity = createReactComponent("wind-electricity", "IconWindElectricity", [
  ["path", { d: "M20 7l-3 5h4l-3 5", key: "svg-0" }],
  ["path", { d: "M3 16h4a2 2 0 1 1 0 4", key: "svg-1" }],
  ["path", { d: "M3 12h8a2 2 0 1 0 0 -4", key: "svg-2" }],
  ["path", { d: "M3 8h3a2 2 0 1 0 0 -4", key: "svg-3" }]
]);

export { IconWindElectricity as default };
//# sourceMappingURL=IconWindElectricity.js.map
